import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "CampaignEditorLeftColumn" }
const _hoisted_2 = { class: "CampaignEditorRightColumn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CrmId = _resolveComponent("CrmId")!
  const _component_Region = _resolveComponent("Region")!
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!

  return (_openBlock(), _createBlock(_component_LoadingWrapper, {
    classes: [
			'CampaignEditorRow',
			'BudgetRow'
		],
    isLoading: _ctx.isLoading
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", {
          class: _normalizeClass([
				'CampaignEditorInputLabel',
				'DropdownLabel',
				'CampaignSettingsInputRequired',
				{ 'ContentInvalid': _ctx.isFieldValidatedAndMissing || _ctx.isFieldValidatedAndInvalid }
			])
        }, " CRM Project ID ", 2 /* CLASS */)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CrmId),
        _createVNode(_component_Region),
        _createElementVNode("div", {
          class: _normalizeClass([
				'ValidationMessage',
				{ 'ContentInvalid': _ctx.isFieldValidatedAndMissing || _ctx.isFieldValidatedAndInvalid }
			])
        }, _toDisplayString(_ctx.validationMessage), 3 /* TEXT, CLASS */)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["isLoading"]))
}